import type { IconProps } from '.';
import "./Explore.linaria.module.css!=!./Explore?./Explore.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNL6uMN8y2KDY1Kqwuz0wpybAy1DMtSs21ruXSA0mnGsGlM1Iz0zNKEPIAFc717D8AAAA="

// const svg = `
// M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z
// `
// const filledSvg = `
// M 9.5 3 A 6.5 6.5 0 0 1 16 9.5 C 16 11.11 15.41 12.59 14.44 13.73 L 14.71 14 H 15.5 L 20.5 19 L 19 20.5 L 14 15.5 V 14.71 L 13.73 14.44 C 12.59 15.41 11.11 16 9.5 16 A 6.5 6.5 0 0 1 3 9.5 A 6.5 6.5 0 0 1 9.5 3 m -1.5 2 L 8 7 Q 12 7 12 11 L 14 11 Q 14 5 8 5 Z
// `

// const ExploreIcon = (props: IconProps) => {
//     const { color } = props
//     return <Icon title="Explore" path={svg} size={1} color={color} />
// }

const exploreStyles = "atm_vy_1k8s52q atm_e2_1k8s52q";
const Explore = ({
  color = 'currentColor',
  filled
}: IconProps) => {
  return <svg fill="none" viewBox="0 0 24 24" color={color} stroke={color} strokeWidth={2} className={exploreStyles}>
            <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" fill={filled ? color : 'none'} strokeLinecap="round" strokeLinejoin="round" />
        </svg>;
};
export default Explore;